import { Code, CodeProps } from "@mantine/core"
import { Missing } from "@tfg/ui"

type Props = {
  value?: string | null
} & CodeProps

export const CodeCell = ({ value, ...props }: Props) =>
  value ? (
    <Code color="green.0" variant="light" {...props}>
      {value}
    </Code>
  ) : (
    <Missing />
  )
